var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('thead',[_c('tr',[_vm._t("slot_head")],2)]),_c('tbody',[_vm._l((_vm.rows),function(row,r){return _vm._t("default",null,{"item":row,"index":r})}),_vm._t("other")],2),_c('tfoot',[_vm._t("foot"),_c('tr',{style:({marginBottom: 'auto',height: '-webkit-fill-available'})},[_c('td')])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }